const SCHOOLS_BY_NAME_HI_RESPONSE = [
  {
    COMBOKEY: '062271012924',
    LEA_NAME: 'Los Angeles Unified',
    LEA_STATE: 'CA',
    RR_AM_F_WH_F_HI: null,
    RR_AM_M_POP_HI: null,
    RR_AM_M_WH_M_HI: null,
    RR_AS_F_POP_HI: null,
    RR_AS_F_WH_F_HI: null,
    RR_AS_M_POP_HI: null,
    RR_AS_M_WH_M_HI: null,
    RR_BL_F_POP_HI: null,
    RR_BL_F_WH_F_HI: null,
    RR_BL_M_POP_HI: null,
    RR_BL_M_WH_M_HI: null,
    RR_HI_F_POP_HI: null,
    RR_HI_F_WH_F_HI: null,
    RR_HI_M_POP_HI: null,
    RR_HI_M_WH_M_HI: null,
    RR_HP_F_POP_HI: null,
    RR_HP_F_WH_F_HI: null,
    RR_HP_M_POP_HI: null,
    RR_HP_M_WH_M_HI: null,
    RR_TR_F_POP_HI: null,
    RR_TR_F_WH_F_HI: null,
    RR_TR_M_POP_HI: null,
    RR_TR_M_WH_M_HI: null,
    RR_WH_F_POP_HI: null,
    RR_WH_M_POP_HI: null,
    SCHOOL_NAME: 'Alliance Margaret M. Bloomfield Technology Academy High',
    __typename: 'Hearingimpairment',
  },
  {
    COMBOKEY: '290525000073',
    LEA_NAME: 'BLOOMFIELD R-XIV',
    LEA_STATE: 'MO',
    RR_AM_F_WH_F_HI: null,
    RR_AM_M_POP_HI: null,
    RR_AM_M_WH_M_HI: null,
    RR_AS_F_POP_HI: null,
    RR_AS_F_WH_F_HI: null,
    RR_AS_M_POP_HI: null,
    RR_AS_M_WH_M_HI: null,
    RR_BL_F_POP_HI: null,
    RR_BL_F_WH_F_HI: null,
    RR_BL_M_POP_HI: null,
    RR_BL_M_WH_M_HI: null,
    RR_HI_F_POP_HI: null,
    RR_HI_F_WH_F_HI: null,
    RR_HI_M_POP_HI: null,
    RR_HI_M_WH_M_HI: null,
    RR_HP_F_POP_HI: null,
    RR_HP_F_WH_F_HI: null,
    RR_HP_M_POP_HI: null,
    RR_HP_M_WH_M_HI: null,
    RR_TR_F_POP_HI: null,
    RR_TR_F_WH_F_HI: null,
    RR_TR_M_POP_HI: null,
    RR_TR_M_WH_M_HI: null,
    RR_WH_F_POP_HI: null,
    RR_WH_M_POP_HI: null,
    SCHOOL_NAME: 'BLOOMFIELD HIGH',
    __typename: 'Hearingimpairment',
  },
  {
    COMBOKEY: '340183001980',
    LEA_NAME: 'BLOOMFIELD TOWNSHIP SCHOOL DISTRICT',
    LEA_STATE: 'NJ',
    RR_AM_F_WH_F_HI: null,
    RR_AM_M_POP_HI: null,
    RR_AM_M_WH_M_HI: null,
    RR_AS_F_POP_HI: null,
    RR_AS_F_WH_F_HI: null,
    RR_AS_M_POP_HI: null,
    RR_AS_M_WH_M_HI: null,
    RR_BL_F_POP_HI: null,
    RR_BL_F_WH_F_HI: null,
    RR_BL_M_POP_HI: null,
    RR_BL_M_WH_M_HI: null,
    RR_HI_F_POP_HI: null,
    RR_HI_F_WH_F_HI: null,
    RR_HI_M_POP_HI: null,
    RR_HI_M_WH_M_HI: null,
    RR_HP_F_POP_HI: null,
    RR_HP_F_WH_F_HI: null,
    RR_HP_M_POP_HI: null,
    RR_HP_M_WH_M_HI: null,
    RR_TR_F_POP_HI: null,
    RR_TR_F_WH_F_HI: null,
    RR_TR_M_POP_HI: null,
    RR_TR_M_WH_M_HI: null,
    RR_WH_F_POP_HI: null,
    RR_WH_M_POP_HI: null,
    SCHOOL_NAME: 'BLOOMFIELD HIGH SCHOOL',
    __typename: 'Hearingimpairment',
  },
  {
    COMBOKEY: '290525003104',
    LEA_NAME: 'BLOOMFIELD R-XIV',
    LEA_STATE: 'MO',
    RR_AM_F_WH_F_HI: null,
    RR_AM_M_POP_HI: null,
    RR_AM_M_WH_M_HI: null,
    RR_AS_F_POP_HI: null,
    RR_AS_F_WH_F_HI: null,
    RR_AS_M_POP_HI: null,
    RR_AS_M_WH_M_HI: null,
    RR_BL_F_POP_HI: null,
    RR_BL_F_WH_F_HI: null,
    RR_BL_M_POP_HI: null,
    RR_BL_M_WH_M_HI: null,
    RR_HI_F_POP_HI: null,
    RR_HI_F_WH_F_HI: null,
    RR_HI_M_POP_HI: null,
    RR_HI_M_WH_M_HI: null,
    RR_HP_F_POP_HI: null,
    RR_HP_F_WH_F_HI: null,
    RR_HP_M_POP_HI: null,
    RR_HP_M_WH_M_HI: null,
    RR_TR_F_POP_HI: null,
    RR_TR_F_WH_F_HI: null,
    RR_TR_M_POP_HI: null,
    RR_TR_M_WH_M_HI: null,
    RR_WH_F_POP_HI: null,
    RR_WH_M_POP_HI: null,
    SCHOOL_NAME: 'BLOOMFIELD MIDDLE',
    __typename: 'Hearingimpairment',
  },
  {
    COMBOKEY: '180060000112',
    LEA_NAME: 'Bloomfield School District',
    LEA_STATE: 'IN',
    RR_AM_F_WH_F_HI: null,
    RR_AM_M_POP_HI: null,
    RR_AM_M_WH_M_HI: null,
    RR_AS_F_POP_HI: null,
    RR_AS_F_WH_F_HI: null,
    RR_AS_M_POP_HI: null,
    RR_AS_M_WH_M_HI: null,
    RR_BL_F_POP_HI: null,
    RR_BL_F_WH_F_HI: null,
    RR_BL_M_POP_HI: null,
    RR_BL_M_WH_M_HI: null,
    RR_HI_F_POP_HI: null,
    RR_HI_F_WH_F_HI: null,
    RR_HI_M_POP_HI: null,
    RR_HI_M_WH_M_HI: null,
    RR_HP_F_POP_HI: null,
    RR_HP_F_WH_F_HI: null,
    RR_HP_M_POP_HI: null,
    RR_HP_M_WH_M_HI: null,
    RR_TR_F_POP_HI: null,
    RR_TR_F_WH_F_HI: null,
    RR_TR_M_POP_HI: null,
    RR_TR_M_WH_M_HI: null,
    RR_WH_F_POP_HI: null,
    RR_WH_M_POP_HI: null,
    SCHOOL_NAME: 'Bloomfield Elementary School',
    __typename: 'Hearingimpairment',
  },
  {
    COMBOKEY: '260609008480',
    LEA_NAME: 'Bloomfield Hills Schools',
    LEA_STATE: 'MI',
    RR_AM_F_WH_F_HI: null,
    RR_AM_M_POP_HI: null,
    RR_AM_M_WH_M_HI: null,
    RR_AS_F_POP_HI: null,
    RR_AS_F_WH_F_HI: null,
    RR_AS_M_POP_HI: null,
    RR_AS_M_WH_M_HI: null,
    RR_BL_F_POP_HI: null,
    RR_BL_F_WH_F_HI: null,
    RR_BL_M_POP_HI: null,
    RR_BL_M_WH_M_HI: null,
    RR_HI_F_POP_HI: null,
    RR_HI_F_WH_F_HI: null,
    RR_HI_M_POP_HI: null,
    RR_HI_M_WH_M_HI: null,
    RR_HP_F_POP_HI: null,
    RR_HP_F_WH_F_HI: null,
    RR_HP_M_POP_HI: null,
    RR_HP_M_WH_M_HI: null,
    RR_TR_F_POP_HI: null,
    RR_TR_F_WH_F_HI: null,
    RR_TR_M_POP_HI: null,
    RR_TR_M_WH_M_HI: null,
    RR_WH_F_POP_HI: null,
    RR_WH_M_POP_HI: null,
    SCHOOL_NAME: 'Bloomfield Hills High School',
    __typename: 'Hearingimpairment',
  },
  {
    COMBOKEY: '260609004242',
    LEA_NAME: 'Bloomfield Hills Schools',
    LEA_STATE: 'MI',
    RR_AM_F_WH_F_HI: null,
    RR_AM_M_POP_HI: null,
    RR_AM_M_WH_M_HI: null,
    RR_AS_F_POP_HI: null,
    RR_AS_F_WH_F_HI: null,
    RR_AS_M_POP_HI: null,
    RR_AS_M_WH_M_HI: null,
    RR_BL_F_POP_HI: null,
    RR_BL_F_WH_F_HI: null,
    RR_BL_M_POP_HI: null,
    RR_BL_M_WH_M_HI: null,
    RR_HI_F_POP_HI: null,
    RR_HI_F_WH_F_HI: null,
    RR_HI_M_POP_HI: null,
    RR_HI_M_WH_M_HI: null,
    RR_HP_F_POP_HI: null,
    RR_HP_F_WH_F_HI: null,
    RR_HP_M_POP_HI: null,
    RR_HP_M_WH_M_HI: null,
    RR_TR_F_POP_HI: null,
    RR_TR_F_WH_F_HI: null,
    RR_TR_M_POP_HI: null,
    RR_TR_M_WH_M_HI: null,
    RR_WH_F_POP_HI: null,
    RR_WH_M_POP_HI: null,
    SCHOOL_NAME: 'Bloomfield Hills Middle School',
    __typename: 'Hearingimpairment',
  },
  {
    COMBOKEY: '292187501218',
    LEA_NAME: 'NEW BLOOMFIELD R-III',
    LEA_STATE: 'MO',
    RR_AM_F_WH_F_HI: null,
    RR_AM_M_POP_HI: null,
    RR_AM_M_WH_M_HI: null,
    RR_AS_F_POP_HI: null,
    RR_AS_F_WH_F_HI: null,
    RR_AS_M_POP_HI: null,
    RR_AS_M_WH_M_HI: null,
    RR_BL_F_POP_HI: null,
    RR_BL_F_WH_F_HI: null,
    RR_BL_M_POP_HI: null,
    RR_BL_M_WH_M_HI: null,
    RR_HI_F_POP_HI: null,
    RR_HI_F_WH_F_HI: null,
    RR_HI_M_POP_HI: null,
    RR_HI_M_WH_M_HI: null,
    RR_HP_F_POP_HI: null,
    RR_HP_F_WH_F_HI: null,
    RR_HP_M_POP_HI: null,
    RR_HP_M_WH_M_HI: null,
    RR_TR_F_POP_HI: null,
    RR_TR_F_WH_F_HI: null,
    RR_TR_M_POP_HI: null,
    RR_TR_M_WH_M_HI: null,
    RR_WH_F_POP_HI: null,
    RR_WH_M_POP_HI: null,
    SCHOOL_NAME: 'NEW BLOOMFIELD ELEM.',
    __typename: 'Hearingimpairment',
  },
  {
    COMBOKEY: '263582007181',
    LEA_NAME: 'West Bloomfield School District',
    LEA_STATE: 'MI',
    RR_AM_F_WH_F_HI: null,
    RR_AM_M_POP_HI: null,
    RR_AM_M_WH_M_HI: null,
    RR_AS_F_POP_HI: null,
    RR_AS_F_WH_F_HI: null,
    RR_AS_M_POP_HI: null,
    RR_AS_M_WH_M_HI: null,
    RR_BL_F_POP_HI: null,
    RR_BL_F_WH_F_HI: null,
    RR_BL_M_POP_HI: null,
    RR_BL_M_WH_M_HI: null,
    RR_HI_F_POP_HI: null,
    RR_HI_F_WH_F_HI: null,
    RR_HI_M_POP_HI: null,
    RR_HI_M_WH_M_HI: null,
    RR_HP_F_POP_HI: null,
    RR_HP_F_WH_F_HI: null,
    RR_HP_M_POP_HI: null,
    RR_HP_M_WH_M_HI: null,
    RR_TR_F_POP_HI: null,
    RR_TR_F_WH_F_HI: null,
    RR_TR_M_POP_HI: null,
    RR_TR_M_WH_M_HI: null,
    RR_WH_F_POP_HI: null,
    RR_WH_M_POP_HI: null,
    SCHOOL_NAME: 'West Bloomfield High School',
    __typename: 'Hearingimpairment',
  },
];

export default SCHOOLS_BY_NAME_HI_RESPONSE;
